/**
 * Vue2file : Velocity.PrimaryOffersites.Web\wwwroot\js\services\TransactServices\TransactBootstrap.js
 * Make changes there also if you are chaning this
 */
import axios from 'axios';
import {
  EXPRESS_CALL_PAYMENTS_DATA,
} from '@/store/types';
import { CASH, FINANCE, LEASE } from '@/js/constants/constants';
import {
  PAYMENT_CONFIGURATION_DOWN_PAYMENT,
  SUMMARY_PAYMENTDATA,
  SUMMARY_SELECTED_VALUES,
} from '@/js/constants/expresspaymentconstants';
import { ExpressPayments } from '../Payments/ExpressPayments';
import { getTransactDeals } from './TransactSummaryService';
import { Payments } from '../Payments/Payments';

import {
  TRANSACT_ACCESSORIES_SECTION,
  TRANSACT_CHECKOUT_SECTION,
  TRANSACT_CREDIT_SECTION,
  TRANSACT_INCENTIVES_SECTION,
  TRANSACT_PAYMENT_SECTION,
  TRANSACT_SERVICE_PROTECTION_SECTION,
  TRANSACT_TAX_SECTION,
  TRANSACT_TRADE_SECTION,
} from '@/store/StoreConstants/TransactConstants';
import { adjustSummaryDataForTab } from '../Payments/PaymentsService';
import { isCurrentThemeOf, SUBARU, VOLKSWAGEN } from '@/js/constants/ThemeConstants';
import { useExpressCheckoutStore } from '../../store/ExpressCheckout/ExpressCheckoutStore/ExpressCheckoutStore';

export async function TransactBootstrap(
  selectedPaymentOption,
  previousValues,
  financeData,
  leaseData
) {
  await getCreditScore();
  await getTransactPaymentSettings();
  await initializeExpressPayments(selectedPaymentOption, previousValues, financeData, leaseData);
  await getConsumerDetails();
  getTransactPaymentTabs();
  await prepareSummaryDataForAllPaymentTabs();
}

export function changeZipCodeStatusToManual() {
  const expressCheckoutStore = useExpressCheckoutStore();
  expressCheckoutStore.isZipCodeChangedManual = true;
}

export async function prepareSummaryDataForAllPaymentTabs() {
  const expressCheckoutStore = useExpressCheckoutStore();
  const activePaymentTabs = expressCheckoutStore.activePaymentTabs;
  const transactPaymentSettings = expressCheckoutStore.paymentSettings;

  for (let item of activePaymentTabs) {
    let expressPaymentSettings = transactPaymentSettings[item.toLowerCase()];
    await adjustSummaryDataForTab(item, expressPaymentSettings);
  }
}

export function getTransactPaymentTabs() {
  let items = [];
  const expressPaymentSettings = useExpressCheckoutStore();
  const leaseData = expressPaymentSettings.summaryData?.['lease']?.['paymentData'];
  const financeData = expressPaymentSettings.summaryData?.['finance']?.['paymentData'];
  const creditScoreFormDetails = expressPaymentSettings.creditScoreFormDetails;
  const selectedPayment = expressPaymentSettings.selectedPaymentOption;

  if (leaseData) {
    items.push(LEASE.toLowerCase());
  }
  if (financeData) {
    items.push(FINANCE.toLowerCase());
  }

  if (creditScoreFormDetails.enableCashOnTransact) {
    items.push('cash');
  } else if (selectedPayment.toLowerCase() === CASH.toLowerCase()) {
    if (items.indexOf(LEASE.toLowerCase()) !== -1) {
      expressPaymentSettings.selectedPaymentOption = LEASE.toLowerCase();
    } else {
      expressPaymentSettings.selectedPaymentOption = FINANCE.toLowerCase();
    }
  } else {
    // No action needed for other cases
  }
  expressPaymentSettings.activePaymentTabs = items;
}

export async function getTransactPaymentSettings() {
  const expressPaymentsObj = new ExpressPayments();
  const response = await expressPaymentsObj.getExpressPaymentSettings();
  expressPaymentsObj.formatPaymentSettings(response.data);
}

export async function initializeExpressPayments(
  selectedPaymentOption,
  previousValues,
  financeData,
  leaseData
) {
  const expressPaymentSettings = useExpressCheckoutStore();
  let dealId = getDealIdInQuery();
  let dealDetails = '';
  if (dealId) {
    dealDetails = await getPaymentsFromDealId(dealId);
    if (dealDetails) {
      setDealDetailsInStoreForTransact(dealDetails);
    }
  }

  if (!dealDetails) {
    chooseSelectedPaymentOption(selectedPaymentOption);
  }

  let previousSelectedValues = '';

  let stateData = JSON.parse(JSON.stringify(expressPaymentSettings.summaryData));
  stateData[FINANCE.toLowerCase()][SUMMARY_PAYMENTDATA] = financeData;

  previousSelectedValues = previousValues[LEASE.toLowerCase()];
  previousSelectedValues.downPayment = parseInt(previousSelectedValues.downPayment);

  stateData[LEASE.toLowerCase()][SUMMARY_SELECTED_VALUES] = previousSelectedValues;

  stateData[LEASE.toLowerCase()][SUMMARY_PAYMENTDATA] = leaseData;

  previousSelectedValues = previousValues[FINANCE.toLowerCase()];
  previousSelectedValues.downPayment = parseInt(previousSelectedValues.downPayment);

  stateData[FINANCE.toLowerCase()][SUMMARY_SELECTED_VALUES] = previousSelectedValues;

  expressPaymentSettings.summaryData = stateData;

  let stateIncentiveData = JSON.parse(JSON.stringify(expressPaymentSettings.incentivesAmount));

  stateIncentiveData['lease'] = leaseData['IncentiveCash'];
  stateIncentiveData['finance'] = financeData['IncentiveCash'];
  expressPaymentSettings.incentivesAmount = stateIncentiveData;

  if (dealDetails) {
    setDealDataInSummary(dealDetails);
  }
}

export async function getCreditScore() {
  try {
    const expressPaymentSettings = useExpressCheckoutStore();
    let response = await axios.get(
      `${window.ApiBaseUrl}/DigitalRetailerSettings/getDigitalRetailerSettings?accountId=${window.accountId}`
    );
    let jsonString = JSON.stringify(response.data);
    jsonString = jsonString.replaceAll('#DealerName', window.clientName);
    let modifiedJson = JSON.parse(jsonString);
    expressPaymentSettings.creditScoreFormDetails = modifiedJson;

    return response.data;
  } catch (err) {
    console.log(err);
  }
}

export async function getConsumerDetails() {
  const expressPaymentSettings = useExpressCheckoutStore();
  let response = '';
  if (window.isauthenticated === 'True') {
    try {
      response = await ExpressPayments.getCurrentVehicle(window.userDetails.consumerid);
      expressPaymentSettings.currentVehicleDetails = response.data;

      return response.data;
    } catch (err) {
      console.log(err);
    }
  }
}

export function getDealIdInQuery() {
  let queryString = window.location.search;
  queryString = queryString ? queryString.substring(1, queryString.length) : '';
  if (!queryString) return false;
  let queryStringParts = queryString.split('&');

  if (!queryStringParts.length) return false;

  for (let query of queryStringParts) {
    let part = query.split('=');
    if (part[0].toLowerCase() === 'dealid') {
      return part[1];
    }
  }
  return false;
}

export async function getPaymentsFromDealId(dealId) {
  let response = '';
  try {
    const expressPaymentSettings = useExpressCheckoutStore();
    expressPaymentSettings.showLoading = true;
    response = await getTransactDeals();
  } catch (e) {
    console.log(e);
  }

  if (response?.data) {
    for (let deal of response.data) {
      if (+deal.dealId === +dealId) {
        return deal;
      }
    }
  }
  return false;
}

export function chooseSelectedPaymentOption(selectedPaymentOption) {
  const expressPaymentSettings = useExpressCheckoutStore();
  expressPaymentSettings.selectedPaymentOption = selectedPaymentOption || CASH.toLowerCase();
}

export function setDealDetailsInStoreForTransact(dealDetails) {
  const expressPaymentSettings = useExpressCheckoutStore();
  dealDetails.paymentDetails = dealDetails.paymentDetails
    ? JSON.parse(dealDetails.paymentDetails)
    : '';
  expressPaymentSettings.dealDetails = dealDetails;

  if (dealDetails?.paymentType) {
    expressPaymentSettings.selectedPaymentOption = dealDetails.paymentType.toLowerCase();
  }
}

export function setDealDataInSummary(dealDetails) {
  const expressPaymentSettings = useExpressCheckoutStore();
  let paymentData = getDealPaymentDetails(dealDetails);
  let paymentDetails = {
    downPayment: Payments.conventStringToNumber(dealDetails.downPayment),
    mileage: Payments.conventStringToNumber(paymentData.MileageAllowance),
    selectedPayment: dealDetails.paymentType.toLowerCase(),
    term: paymentData.Term,
    tradeValue: dealDetails.equity,
  };
  if (dealDetails.creditScore) {
    expressPaymentSettings.selectedCreditScore = dealDetails.creditScore;
    expressPaymentSettings.calculatePaymentsOnTabChanged = true;
  }

  if (dealDetails.appliedTrade) {
    expressPaymentSettings.selectedTradeValue = Payments.conventStringToNumber(
      dealDetails.appliedTrade
    );
  }
  if (dealDetails.taxesRegion) {
    expressPaymentSettings.selectedCityIndex = dealDetails.taxesRegion;
  }
  if (dealDetails.taxesZipCode) {
    sessionStorage.setItem(window.tid + '-tax-zip-code', String(dealDetails.taxesZipCode));
    state.taxZipCode = dealDetails.taxesZipCode;
  }

  expressPaymentSettings.mainTradeValue = Payments.conventStringToNumber(
    getMainTradeValueFromDeal(dealDetails)
  );

  if (dealDetails.appliedTrade) {
    expressPaymentSettings.selectedTradeValue = Payments.conventStringToNumber(
      dealDetails.appliedTrade
    );
  }

  expressPaymentSettings.expressPaymentConfiguration = paymentDetails;

  let stateData = JSON.parse(JSON.stringify(expressPaymentSettings.summaryData));
  stateData[dealDetails.paymentType.toLowerCase()][SUMMARY_PAYMENTDATA] = paymentData;
  stateData[dealDetails.paymentType.toLowerCase()][SUMMARY_SELECTED_VALUES] = paymentDetails;
  expressPaymentSettings.summaryData = stateData;
}

export function getPaymentTypeStatementOnAppliesOptions(state) {
  if (state.dealDetails?.paymentType) {
    let paymentType = state.dealDetails.paymentType;
    return (
      'Paying off your ' + paymentType[0].toUpperCase() + paymentType.substr(1, paymentType.length)
    );
  }

  if (
    +state.expressPaymentConfiguration[PAYMENT_CONFIGURATION_DOWN_PAYMENT] &&
    state.currentVehicleDetails.paymentType
  ) {
    if (
      state.currentVehicleDetails.paymentType.toLowerCase() === FINANCE.toLowerCase() ||
      state.currentVehicleDetails.paymentType.toLowerCase() === LEASE.toLowerCase()
    ) {
      return 'Paying off your ' + state.currentVehicleDetails.paymentType;
    }
  }
  return '';
}

export async function getInitialPayments() {
  const expressPaymentSettings = useExpressCheckoutStore();
  let paymentDetails = {
    downPayment: '',
    mileage: '',
    selectedPayment: '',
    term: '',
    tradeValue: '',
  };
  expressPaymentSettings.expressPaymentConfiguration = paymentDetails;

  await expressPaymentSettings[EXPRESS_CALL_PAYMENTS_DATA]();
}

export function getLoggedInSelectedCity(state, response, selectedSettings) {
  const expressPaymentSettings = useExpressCheckoutStore();
  if (window.isauthenticated === 'True') {
    let selectedCityIndex = 0;
    if (state.dealDetails) {
      if (state.dealDetails.taxesRegion) {
        selectedCityIndex = ExpressPayments.getSelectedCity(response, {
          city: state.dealDetails.taxesRegion,
        });
        expressPaymentSettings.selectedCityIndex = selectedCityIndex;
      }
    } else if (!selectedSettings.useDealerZipCodeForTaxes) {
      selectedCityIndex = ExpressPayments.getSelectedCity(response, state.currentVehicleDetails);
    } else {
      // No action needed for other cases
    }
    expressPaymentSettings.selectedCityIndex = selectedCityIndex;
  }
}

export function getDealPaymentDetails(dealDetails) {
  if (dealDetails?.paymentDetails) {
    let paymentDetails = dealDetails.paymentDetails;
    if (typeof dealDetails.paymentDetails === 'string') {
      paymentDetails = JSON.parse(dealDetails.paymentDetails);
    }

    if (paymentDetails?.summaryData) {
      return paymentDetails.summaryData;
    }
    return paymentDetails;
  }
  return '';
}

export function getMainTradeValueFromDeal(dealDetails) {
  if (dealDetails?.paymentDetails) {
    let paymentDetails = dealDetails.paymentDetails;
    if (typeof dealDetails.paymentDetails === 'string') {
      paymentDetails = JSON.parse(dealDetails.paymentDetails);
    }

    if (paymentDetails?.mainTradeValue) {
      return paymentDetails.mainTradeValue;
    }
  }
  return '';
}

export function getSelectedTradeValueFromDeal(dealDetails) {
  if (dealDetails?.paymentDetails) {
    let paymentDetails = dealDetails.paymentDetails;
    if (typeof dealDetails.paymentDetails === 'string') {
      paymentDetails = JSON.parse(dealDetails.paymentDetails);
    }

    if (paymentDetails?.selectedTradeValue) {
      return paymentDetails.selectedTradeValue;
    }
  }
  return '';
}

export function setActiveTransactSections(digitalSettings) {
  const expressPaymentSettings = useExpressCheckoutStore();
  //Lease Steps
  let leaseActiveSteps = getLeaseActiveSteps(digitalSettings.lease);
  expressPaymentSettings.activeTransactSections['lease'] = leaseActiveSteps;

  //Finance Steps
  let financeActiveSteps = getLeaseActiveSteps(digitalSettings.finance);
  expressPaymentSettings.activeTransactSections['finance'] = financeActiveSteps;

  //cash Steps
  expressPaymentSettings.activeTransactSections['cash'] = financeActiveSteps;
}

export function getLeaseActiveSteps(digitalSettings) {
  let activeSteps = [TRANSACT_PAYMENT_SECTION];

  //for incentives
  if (digitalSettings?.showIncentives) {
    activeSteps.push(TRANSACT_INCENTIVES_SECTION);
  }

  //forTrade
  if (digitalSettings?.showTradeIn) {
    activeSteps.push(TRANSACT_TRADE_SECTION);
  }

  //forCreditScore
  if (digitalSettings?.showCreditScore) {
    activeSteps.push(TRANSACT_CREDIT_SECTION);
  }

  //for taxes
  if (digitalSettings?.showTaxesAndFees && checkTaxesValidForVehicle()) {
    activeSteps.push(TRANSACT_TAX_SECTION);
  }

  //for service protection plans
  if (digitalSettings?.showServiceAndProtectionPlans) {
    activeSteps.push(TRANSACT_SERVICE_PROTECTION_SECTION);
  }
  //for accessories section
  if (isSubaruAccessoriesAvailable()) {
    activeSteps.push(TRANSACT_ACCESSORIES_SECTION);
  }

  //for schedule delivery
  if (digitalSettings?.showScheduleDelivery) {
    activeSteps.push(TRANSACT_CHECKOUT_SECTION);
  }

  return activeSteps;
}

export function checkTaxesValidForVehicle() {
  let year = window.year;
  let taxesValid = true;
  if (year) {
    year = +window.year;
    let currentYear = new Date().getFullYear();
    if (currentYear - year > 3) {
      taxesValid = false;
    }
  }
  return taxesValid;
}

export function transactActiveSectionLoaded(type, value) {
  const expressPaymentSettings = useExpressCheckoutStore();
  let steps = expressPaymentSettings.activeTransactSectionsLoaded[type];
  if (steps.indexOf(payload.value) === -1) {
    expressPaymentSettings.activeTransactSectionsLoaded[type].push(value);
  }
}

export function setTradeValuesFromDeal(dealDetails) {
  const expressPaymentSettings = useExpressCheckoutStore();
  let mainTradeValue = +getMainTradeValueFromDeal(dealDetails);
  let selectedTradeValue = +getSelectedTradeValueFromDeal(dealDetails);

  expressPaymentSettings.selectedTradeValue = selectedTradeValue;
  expressPaymentSettings.mainTradeValue = mainTradeValue;
}

export function checkForPaymentsOverlayEnabled(paymentsOverlayData, unLockEPrice, selectedPayment) {
  if (!paymentsOverlayData.enableOverleyOnTransact) {
    return false;
  }

  if (window.isauthenticated === 'True') {
    if (!paymentsOverlayData.showForLoggedInUsers) {
      return false;
    }
  }

  if (!unLockEPrice) {
    return false;
  }

  if (!paymentsOverlayData.isLeasePayment && selectedPayment === 'lease') {
    return false;
  }
  if (!paymentsOverlayData.isFinancePayment && selectedPayment === 'finance') {
    return false;
  }
  return !(!paymentsOverlayData.isCashPayment && selectedPayment === 'cash');
}

export function isSubaruAccessoriesAvailable() {
  return isCurrentThemeOf(SUBARU, VOLKSWAGEN) && window.enableOemAccessoriesIntegration;
}
